const NUMBER_PATTERN = /(\d[\d.,]*)/;

const formatNumber = (value) => {
	return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(Math.round(value));
};

const animateNumber = (element, targetNumber, suffix) => {
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const duration = prefersReducedMotion ? 0 : 1400;
	const startTime = performance.now();

	const tick = (currentTime) => {
		if (duration === 0) {
			element.textContent = `${formatNumber(targetNumber)}${suffix}`;
			return;
		}

		const elapsed = currentTime - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const easedProgress = 1 - Math.pow(1 - progress, 3);
		const currentValue = targetNumber * easedProgress;

		element.textContent = `${formatNumber(currentValue)}${suffix}`;

		if (progress < 1) {
			window.requestAnimationFrame(tick);
		}
	};

	window.requestAnimationFrame(tick);
};

const parseHeading = (element) => {
	const originalText = element.textContent?.trim() || "";
	const match = originalText.match(NUMBER_PATTERN);

	if (!match) {
		return null;
	}

	const numericValue = Number.parseFloat(match[1].replace(/,/g, "."));

	if (Number.isNaN(numericValue)) {
		return null;
	}

	const suffix = originalText.slice(match.index + match[1].length);

	return {
		targetNumber: numericValue,
		suffix,
	};
};

export const statsCounter = () => {
	const statsSections = document.querySelectorAll(".stats");

	if (!statsSections.length) {
		return;
	}

	const observedHeadings = new WeakSet();

	const activateStats = (section) => {
		section.querySelectorAll(".stat__heading").forEach((heading) => {
			if (observedHeadings.has(heading)) {
				return;
			}

			const parsedHeading = parseHeading(heading);

			if (!parsedHeading) {
				return;
			}

			observedHeadings.add(heading);
			heading.textContent = `0${parsedHeading.suffix}`;
			animateNumber(heading, parsedHeading.targetNumber, parsedHeading.suffix);
		});
	};

	if (!("IntersectionObserver" in window)) {
		statsSections.forEach(activateStats);
		return;
	}

	const observer = new IntersectionObserver((entries, currentObserver) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}

			activateStats(entry.target);
			currentObserver.unobserve(entry.target);
		});
	}, {
		threshold: 0.35,
		rootMargin: "0px 0px -10% 0px",
	});

	statsSections.forEach((section) => {
		observer.observe(section);
	});
};